
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["convertComponent","compileJS"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "58866e5b6a9b9a46be29.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			